import { useContext } from "react";
import useSignFormPayload from "../form/hooks/useSignFormPayload";
import { Card } from "react-bootstrap";
import Signature from "../../../CommonComponents/Signature/Signature";

export default function PdfTemplateDisplay() {
    const {
        pdfUrl, handleSubmit, studentData, loadSignatures, payload
    } = useSignFormPayload();

    const { template_id, batch_student_id, student_id } = payload;
    const shouldDisplay = template_id && batch_student_id && pdfUrl;

    return (
        <Card className="">
            <Card.Body>
                {!template_id && <div>Please select PDF template</div>}
                {!batch_student_id && <div>Please select student</div>}
                
                {shouldDisplay && (
                    <>
                        <div className="pdf-viewer">
                            <embed
                                src={pdfUrl}
                                type="application/pdf"
                                width="100%"
                                height="600px"
                            />
                        </div>
                        
                        <Signature
                            key={batch_student_id}
                            onSubmit={handleSubmit} 
                            studentId={student_id}
                            loadingSignatures={loadSignatures}
                            additionalPayloadData={payload}
                        />
                    </>
                )}
            </Card.Body>
        </Card>
    );
}